
/**
 * @hidden
 */
export interface RequestData {
    id: number;
    type: string;
}

/**
 * @hidden
 */
export interface ResponseData {
    id: number;
    type: string;
    err?: unknown;
}

/**
 * @hidden
 */
export function isCorrelated(response: ResponseData, id: number): boolean {
    const responseId = response.id;
    return responseId === id;
}

/**
 * @hidden
 */
export function generateCorrelationId(): number {
    return Math.random();
}
